// extracted by mini-css-extract-plugin
export var columnItem = "_dl-3";
export var columnItemDraggable = "_dl-5";
export var dragHandle = "_dl-0";
export var dragHandleHovered = "_dl-1";
export var dropdown = "_dl-6";
export var dropdownContent = "_dl-8";
export var dropdownInner = "_dl-7";
export var filterDropdownHeader = "_dl-9";
export var icon = "_dl-2";
export var moveToTopButton = "_dl-4";
export var sectionDivider = "_dl-a";